import React from 'react';
import './home.css';
import error from './../assets/errorScreen.png';
import sorry from './../assets/error.svg';
import Preloader from '../components/layout/preloader';
import Adaptive from './adaptivity';

const Error = () => {
    return ( <>
    <Adaptive />
    <main>
        <section>
        <Preloader />
        <div className="container errCont">
            <div className="errimgCont">
            <img src={error} alt="" />
            <img className='tilt' src={sorry} alt="" />
            </div>
           <div className="s2Text">
         <h1>
             !عذرا
            </h1>
            <h3>
                يوجد خطأ في مدخلاتك. حاول مرة أخرى
            </h3>
    </div>
        </div>
    </section>
    </main>
    </> );
}
export default Error;